// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnderConstruction_constructionOverlay__zekCE {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(3px);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
}

.UnderConstruction_constructionModal__f\\+XzI {
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  text-align: center;
  max-width: 400px;
  animation: UnderConstruction_fadeIn__0-iA\\+ 0.5s ease;
}
.UnderConstruction_constructionModal__f\\+XzI img {
  width: 150px;
  height: auto;
  margin-bottom: 20px;
}
.UnderConstruction_constructionModal__f\\+XzI h2 {
  font-size: 24px;
  color: #1D283C;
  margin-bottom: 10px;
}
.UnderConstruction_constructionModal__f\\+XzI p {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
}

@keyframes UnderConstruction_fadeIn__0-iA\\+ {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/component/ui/Common/UnderConstruction.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,0BAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,qDAAA;AACF;AACE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AACJ;AAEE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAAJ;AAGE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AADJ;;AAKA;EACE;IAAO,UAAA;IAAY,4BAAA;EAAnB;EACA;IAAK,UAAA;IAAY,wBAAA;EAGjB;AACF","sourcesContent":[".constructionOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(3px);\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: auto;\n}\n\n.constructionModal {\n  background-color: white;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  text-align: center;\n  max-width: 400px;\n  animation: fadeIn 0.5s ease;\n  \n  img {\n    width: 150px;\n    height: auto;\n    margin-bottom: 20px;\n  }\n  \n  h2 {\n    font-size: 24px;\n    color: #1D283C;\n    margin-bottom: 10px;\n  }\n  \n  p {\n    font-size: 16px;\n    color: #666;\n    line-height: 1.5;\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-20px); }\n  to { opacity: 1; transform: translateY(0); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"constructionOverlay": `UnderConstruction_constructionOverlay__zekCE`,
	"constructionModal": `UnderConstruction_constructionModal__f+XzI`,
	"fadeIn": `UnderConstruction_fadeIn__0-iA+`
};
export default ___CSS_LOADER_EXPORT___;
